module.exports = __webpack_public_path__ + "static/media/staffpad.e992092e.png";